<div class="card border-0 shadow-sm mb-4 position-relative">
  <div class="page-disable-overlay bg-dark opacity-50 position-absolute w-100 h-100 top-0 start-0">
  </div>
  <div class="card-header bg-warning text-dark">
    <h5 class="card-title mb-0">
      <i class="fa fa-shield-alt me-2"></i>
      Security Settings
    </h5>
  </div>
  <div class="card-body">
    <form class="row g-3">
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Session Timeout (minutes)</label>
        <input type="number" class="form-control" placeholder="30">
      </div>
      <div class="col-12 col-md-6">
        <label class="form-label fw-semibold">Password Minimum Length</label>
        <input type="number" class="form-control" placeholder="8" min="6" max="50">
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="requireUppercase">
          <label class="form-check-label" for="requireUppercase">
            Require Uppercase Letters in Password
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="requireNumbers">
          <label class="form-check-label" for="requireNumbers">
            Require Numbers in Password
          </label>
        </div>
      </div>
      <div class="col-12">
        <div class="form-check">
          <input class="form-check-input" type="checkbox" id="enableTwoFactor">
          <label class="form-check-label" for="enableTwoFactor">
            Enable Two-Factor Authentication
          </label>
        </div>
      </div>
      <div class="col-12">
        <button type="submit" class="btn btn-warning">
          <i class="fa fa-save me-1"></i>
          Save Security Settings
        </button>
      </div>
    </form>
  </div>
</div>
